import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { cn } from "@/lib/utils";
import type { BrickType } from "../../masterImages/types";

export const BRICK_TYPE_LABELS: Record<BrickType, string> = { full: "Heel", half: "Half" };

interface Props {
  value: BrickType | undefined;
  onChange(type: BrickType): void;
  className?: string;
  disabled?: boolean;
}

// Full or half brick. Arrow keys are left to the page (the editor nudges regions with them).
const BrickTypeToggle: React.FC<Props> = ({ value, onChange, className, disabled }) => (
  <ToggleGroup
    type="single"
    rovingFocus={false}
    value={value ?? ""}
    onValueChange={(next) => next && onChange(next as BrickType)}
    className={cn(className)}
    disabled={disabled}
    aria-label="Type steen"
  >
    {(Object.keys(BRICK_TYPE_LABELS) as BrickType[]).map((type) => (
      <ToggleGroupItem key={type} value={type} className="h-6 text-xs">
        {BRICK_TYPE_LABELS[type]}
      </ToggleGroupItem>
    ))}
  </ToggleGroup>
);

export default BrickTypeToggle;
